import {
  IconAdd,
  LogoBinance,
  LogoBitget,
  LogoHSCT,
  LogoOKX,
  LogoPropertyGuru,
  LogoSotalab,
  LogoSui,
  LogoTitan,
} from '@/assets';
import useResponsive from '@/hooks/useResponsive';
import React from 'react';
import { useTranslation } from 'react-i18next';

const SectionOurCustomer = () => {
  const isMobile = useResponsive();
  const { t } = useTranslation();
  return (
    <section className="our-customers">
      <div className="line" />
      <div className="our-customers__left">
        <p className="title">{t('Our Customers')}</p>
        <p className="desc">
          {t(
            'Our customers inspire everything we do. We serve a diverse community, tailoring solutions to meet their unique needs and drive their success.'
          )}
        </p>
      </div>
      <div className="our-customers__right">
        {isMobile ? (
          <>
            <div className="row-box-mobile">
              <div className="box-item">
                <LogoTitan className="logo logo-first" />
                <LogoBitget className="logo logo-second" />
              </div>
              <div className="box-item">
                <LogoPropertyGuru className="logo logo-first" />
                <LogoSotalab className="logo logo-second" />
              </div>
            </div>
            <div className="row-box-mobile">
              <div className="box-item">
                <LogoHSCT className="logo logo-first" />
                <LogoOKX className="logo logo-second" />
              </div>
              <div className="box-item">
                <LogoBinance className="logo logo-first" />
                <LogoSui className="logo logo-second" />
              </div>
            </div>
            <div className="row-box-mobile">
              <div className="box-item">
                <LogoOKX className="logo logo-first" />
                <LogoPropertyGuru className="logo logo-second" />
              </div>
              <div className="box-item">
                <LogoSui className="logo logo-first" />
                <LogoBinance className="logo logo-second" />
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="row-box">
              <div className="box-item"></div>
              <div className="box-item">
                <LogoTitan className="logo logo-first" />
                <LogoBitget className="logo logo-second" />
              </div>
              <div className="box-item"></div>
              <div className="box-item">
                <LogoPropertyGuru className="logo logo-first" />
                <LogoSotalab className="logo logo-second" />
                <div className="icon-add">
                  <IconAdd />
                </div>
              </div>
            </div>
            <div className="row-box">
              <div className="box-item"></div>
              <div className="box-item">
                <div className="icon-add">
                  <IconAdd />
                </div>
              </div>
              <div className="box-item">
                <LogoHSCT className="logo logo-first" />
                <LogoOKX className="logo logo-second" />
              </div>
              <div className="box-item">
                <LogoBinance className="logo logo-first" />
                <LogoSui className="logo logo-second" />
              </div>
            </div>
            <div className="row-box">
              <div className="box-item">
                <div className="icon-add">
                  <IconAdd />
                </div>
              </div>
              <div className="box-item">
                <LogoOKX className="logo logo-first" />
                <LogoPropertyGuru className="logo logo-second" />
              </div>
              <div className="box-item">
                <LogoSui className="logo logo-first" />
                <LogoBinance className="logo logo-second" />
              </div>
              <div className="box-item">
                <div className="icon-add">
                  <IconAdd />
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export default React.memo(SectionOurCustomer);
